import { format } from 'date-fns';
import { BackgroundExportTypes } from 'further-types/background-exports';
import { BackgroundExportTypeLabels } from '../../labels';

const getDownloadTitle = (download: {
  exportType?: BackgroundExportTypes;
  createdAt?: Date;
  firmName?: string;
}) => {
  if (!download.exportType || !download.createdAt) {
    return '';
  }

  const { exportType, createdAt } = download;
  const time = format(createdAt, 'HH:mm');

  return `${BackgroundExportTypeLabels[exportType]} - ${time}`;
};

export default getDownloadTitle;
